export const isDocumentFullscreen = (fullscreenDocument = document) =>
  Boolean(
    fullscreenDocument?.fullscreenElement ||
      fullscreenDocument?.mozFullScreenElement ||
      fullscreenDocument?.webkitFullscreenElement ||
      fullscreenDocument?.msFullscreenElement,
  );

const callFullscreenMethod = async (target, methodNames) => {
  if (!target) return false;

  const methodName = methodNames.find(
    (candidate) => typeof target[candidate] === "function",
  );
  if (!methodName) return false;

  try {
    await Promise.resolve(target[methodName].call(target));
    return true;
  } catch (_error) {
    return false;
  }
};

export const requestElementFullscreen = (element) =>
  callFullscreenMethod(element, [
    "requestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen",
    "msRequestFullscreen",
  ]);

export const exitDocumentFullscreen = (fullscreenDocument = document) =>
  callFullscreenMethod(fullscreenDocument, [
    "exitFullscreen",
    "mozCancelFullScreen",
    "webkitExitFullscreen",
    "msExitFullscreen",
  ]);
